module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s9-0f35734b212ea708119521caaa698893.jpg";